
import { VueConstructor } from 'vue';
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  EventType,
  FormDto,
  HeaderSectionLayout,
  HeaderSectionModel,
  PageDto,
  TranslatableField,
  WebsiteHeaderProps,
} from '../../../services';
import WebsiteHeaderBoxed from './WebsiteHeaderBoxed.vue';
import WebsiteHeaderFullWidth from './WebsiteHeaderFullWidth.vue';
import WebsiteHeaderLifted from './WebsiteHeaderLifted.vue';
import WebsiteHeaderSplit from './WebsiteHeaderSplit.vue';

@Component
export default class WebsiteHeader extends Vue {
  @Prop({ type: Object, required: true }) readonly headerSection!: HeaderSectionModel;
  @Prop({ type: Object, required: true }) readonly name!: TranslatableField;
  @Prop({ type: String, required: true }) readonly startDate!: string;
  @Prop({ type: String, required: true }) readonly endDate!: string;
  @Prop({ type: String, required: true }) readonly type!: EventType;
  @Prop({ type: Object, required: true }) readonly place!: TranslatableField;
  @Prop({ type: Array, required: true }) readonly forms!: FormDto[];
  @Prop({ type: Object, required: true }) readonly registrationPage!: PageDto | undefined;
  @Prop({ type: Object, required: true }) readonly submissionPage!: PageDto | undefined;
  @Prop({ type: Boolean, default: false }) readonly readOnly!: boolean;

  public readonly headerComponentsMap: Partial<Record<HeaderSectionLayout, VueConstructor>> = {
    [HeaderSectionLayout.Boxed]: WebsiteHeaderBoxed,
    [HeaderSectionLayout.FullWidth]: WebsiteHeaderFullWidth,
    [HeaderSectionLayout.Lifted]: WebsiteHeaderLifted,
    [HeaderSectionLayout.Split]: WebsiteHeaderSplit,
  };

  get headerComponent(): VueConstructor {
    return this.headerComponentsMap[this.headerSection.layout] ?? WebsiteHeaderBoxed;
  }

  get websiteHeaderProps(): WebsiteHeaderProps {
    return {
      headerSection: this.headerSection,
      name: this.name,
      startDate: this.startDate,
      endDate: this.endDate,
      type: this.type,
      place: this.place,
      forms: this.forms,
      registrationPage: this.registrationPage,
      submissionPage: this.submissionPage,
      readOnly: this.readOnly,
    };
  }
}
